var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.formatDescription),function(description,index){return _c('li',{key:index},[_vm._v("\n    "+_vm._s(description)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }